// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"92c4b8af","219":"46fc9359","425":"d44fce4f"}[chunkId] + ".chunk.js";
};